import React from "react";
import { Link } from "react-router-dom";

function OurProjects() {
  return (
    <div>
      <section className="case-study-section-two bg-dark">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            {/* Section Heading */}
            <div className="col-12 col-sm-9 col-md-8 col-lg-7 col-xl-6">
              <div className="section-heading text-center">
                <div className="sub-title text-white justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Case Studies
                </div>
                <h2 className="text-white">Explore Latest Case Studies</h2>
              </div>
            </div>
          </div>
        </div>

        {/* Case Study Slider */}
        <div className="swiper case-study-two-swiper">
          <div className="swiper-wrapper">
            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/24.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/25.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/26.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/24.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/24.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/25.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/26.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>

            {/* Case Study Slide */}
            <div className="swiper-slide">
              <div className="case-study-card-two">
                <img className="w-100" src="assets/img/bg-img/24.jpg" alt="" />

                {/* Overlay Content */}
                <div className="overlay-content d-flex flex-column justify-content-end">
                  <div className="case-study-title2">Business &amp; Family</div>
                  <p className="mb-2">
                    Fusce sodales nec sem ac volutpat. Aenean vel viverra diam,
                    a laoreet tortor.
                  </p>
                  <Link to="#">
                    <i className="ti ti-arrow-right"></i>
                  </Link>
                </div>

                {/* Content */}
                <div className="case-study-title">Business &amp; Family</div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="case-study-two-pagination"></div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default OurProjects;
